import createTypes from 'redux-create-action-types';

export default createTypes(
  // Inspection
  'GET_INSPECTION_DETAIL',
  'CREATE_INSPECTION',
  'UPDATE_INSPECTION'
);
